export const range = (n: number) => [...Array(n).keys()];
